export const convertSaveCardObject = (resultData: any) => {
  return {
    position: resultData.position || "",
    phone: resultData.phone || "",
    messenger: resultData.messenger || "",
  };
};
